export const windsAloftLink =
  "https://aviationweather.gov/data/windtemp/?region=mia&fcst=12&level=low";

export const metarsLink =
  "https://aviationweather.gov/data/metar";

export const tafsLink =
  "https://aviationweather.gov/data/taf";

export const adipFaaLink =
  "https://adip.faa.gov/agis/public/#/public";

export const terminalLink =
  "https://www.faa.gov/air_traffic/flight_info/aeronav/digital_products/dtpp/search/";

export const notamsLink =
"https://notams.aim.faa.gov/notamSearch/nsapp.html#/";  

export const windsLink =
"https://aviationweather.gov/data/windtemp/?region=mia&fcst=12&level=low";


